import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  height: '100vh',
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [openNavMobile, setOpenNavMobile] = useState(false);
  const [openNavDesktop, setOpenNavDesktop] = useState(true);

  return (
    <StyledRoot>
      <Header
        onOpenNav={() => setOpenNavMobile(true)}
        onToggleDesktopNav={() => setOpenNavDesktop((prev) => !prev)}
        isDesktopNavOpen={openNavDesktop}
      />

      <Nav
        openNav={openNavMobile}
        onCloseNav={() => setOpenNavMobile(false)}
        isDesktopNavOpen={openNavDesktop}
      />

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
